// src/components/ui/RightForYouItem.tsx
import type { ReactNode } from "react";
import React from "react";

interface RightForYouItemProps {
  icon: ReactNode;
  description: string;
}

const RightForYouItem: React.FC<RightForYouItemProps> = ({
  icon,
  description,
}) => (
  <li className="flex flex-col items-center text-center bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300 overflow-visible">
    <div className="flex items-center justify-center bg-gradient-to-r from-pink-500 to-red-500 rounded-full p-4 mb-4">
      {icon}
    </div>
    <p className="text-lg md:text-xl text-gray-700 leading-snug">
      {description}
    </p>
  </li>
);

export default RightForYouItem;
